import styled from "styled-components";
import { V3Title } from "../Typography";

export const PageTitle = styled(V3Title)`
    font-size: 20px;
`;